import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable } from 'rxjs';
import { Deal } from 'app/models/dto/deal.model';

@Injectable({
  providedIn: 'root'
})
export class LenderApiService {

  apiActions = {
    OnDeckCapital: {
      application: true,
      documents: true,
      hideDocumentWarning: false,
      completeAtLender: false,
      sentEmail: false,
      status: true,
      skipErrorFormatting: false,
      hideSendToLenderPortal: true
    },
    CANCapital: {
      application: false,
      documents: false,
      hideDocumentWarning: false,
      completeAtLender: false,
      sentEmail: false,
      status: false,
      skipErrorFormatting: false,
      hideSendToLenderPortal: false
    },
    LendingClub: {
      application: true,
      documents: false,
      hideDocumentWarning: false,
      completeAtLender: true,
      sentEmail: false,
      status: false,
      skipErrorFormatting: true,
      hideSendToLenderPortal: true
    },
    eProdigy: {
      application: true,
      documents: false,
      hideDocumentWarning: false,
      completeAtLender: false,
      sentEmail: false,
      status: false,
      skipErrorFormatting: false
    },
    Kabbage: {
      application: true,
      documents: false,
      hideDocumentWarning: false,
      completeAtLender: true,
      sentEmail: true,
      status: false,
      skipErrorFormatting: false,
      hideSendToLenderPortal: true
    },
    AmericanExpress: {
      application: true,
      documents: false,
      hideDocumentWarning: true,
      completeAtLender: false,
      sentEmail: false,
      status: false,
      skipErrorFormatting: false,
      hideSendToLenderPortal: true
    }
  };

  constructor(private http: ApiHttpClient) { }

  getSupportedApiActions(deal: Deal) {
    let supportedActions: any;
    try {
      const lenderName = this.formatApiName(deal.loan_product_lender.name);
      supportedActions = this.apiActions[lenderName] || {};
    } catch (e) {
      supportedActions = {};
    }
    return supportedActions;
  }

  postApplication(deal: Deal) {
    return this.http.post('/lender-api/apply', this.formatDeal(deal));
  }

  getDealStatus(dealId: number): Observable<any> {
    return this.http.post('/lender-api/status/', { 'dealId': dealId });
  }

  private formatDeal(deal: Deal) {
    return {
      dealId: deal.id,
      lender: this.formatApiName(deal.loan_product_lender.name)
    };
  }

  private formatApiName(name: string) {
    return name.replace(/\s+/g, '').replace(/&/g, 'And');
  }
}
